import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {Helmet} from "react-helmet";
import { SeoHandlerClass } from '../../utils/seo-handler.class';
import { FAQDATA } from '../../constants/constants';

export const SeoDetails = () => {
    const { pathname } = useLocation();
    const [seoDetails, setSeoDetails] = useState<any>(null)
    const [structuredJSON, setStructuredJSON] = useState<any>();

    useEffect(() => {
        // window.scrollTo(0, 0);
        (async () => {
            const seoHandler = new SeoHandlerClass(pathname);
            const fetchedSeoDetails = await seoHandler.getSeoDetails(pathname);
            setSeoDetails({ ...fetchedSeoDetails });
        })();
    }, [pathname]);

    useEffect(() => {
        if (pathname == "/") {
            let JSONProduct = {};
            let productSchema = FAQDATA;
            if (productSchema) {
                JSONProduct = productSchema;
                setStructuredJSON(JSON.stringify(JSONProduct))
            }
        } else {
            setStructuredJSON(null)
        }
    }, [pathname])


    return (<>
    {seoDetails &&
    <Helmet>
        <title>{seoDetails?.title || 'Taxmann'}</title>
        <link rel="canonical" href={window.location.href} />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        <meta name="keywords" content={seoDetails?.keywords} />
        <meta name="description" content={seoDetails?.description} />
        <meta name="robots" content={location.hostname.indexOf('www') !== -1 ? (seoDetails?.robots || 'noindex, nofollow') : 'noindex, nofollow'} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="https://www.taxmann.com" />
        <meta property="og:title" content={seoDetails?.og?.title || seoDetails?.title} />
        <meta property="og:description" content={seoDetails?.og?.description || seoDetails?.description} />
        <meta property="og:image" content={seoDetails?.og?.image || seoDetails?.image || 'https://cdn.taxmann.com/taxmann-images/taxmann-premium/og-premium-logo.png'} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="taxmann.com" />
        <meta property="twitter:url" content={window.location.href} />
        <meta name="twitter:site" content="@taxmannindia" />
        <meta name="twitter:title" content={seoDetails?.og?.title || seoDetails?.title} />
        <meta name="twitter:description" content={seoDetails?.og?.description || seoDetails?.description} />
        <meta name="twitter:image" content={seoDetails?.og?.image || seoDetails?.image || 'https://cdn.taxmann.com/taxmann-images/taxmann-premium/premium-logo.gif'} />
        {structuredJSON && <script className='structured-data-list' type="application/ld+json">{structuredJSON}</script> }
    </Helmet>
    }
    </>)
}
